"use strict";
import { __require as fr } from "./index.es303.js";
import { __require as ur } from "./index.es304.js";
import { __require as sr } from "./index.es305.js";
import { __require as cr } from "./index.es306.js";
import { __require as lr } from "./index.es307.js";
import { __require as Ar } from "./index.es308.js";
import { __require as dr } from "./index.es103.js";
import { __require as mr } from "./index.es309.js";
import { __require as vr } from "./index.es310.js";
import { __require as Pr } from "./index.es311.js";
import { __require as gr } from "./index.es312.js";
import { __require as _r } from "./index.es313.js";
import { __require as hr } from "./index.es314.js";
import { __require as Sr } from "./index.es315.js";
import { __require as Er } from "./index.es316.js";
import { __require as qr } from "./index.es317.js";
import { __require as Ir } from "./index.es318.js";
import { __require as br } from "./index.es319.js";
import { __require as Fr } from "./index.es320.js";
import { __require as Rr } from "./index.es321.js";
import { __require as Ur } from "./index.es322.js";
import { __require as wr } from "./index.es323.js";
import { __require as Or } from "./index.es324.js";
import { __require as Br } from "./index.es325.js";
import { __require as xr } from "./index.es326.js";
var w, $;
function ne() {
  if ($) return w;
  $ = 1;
  var r, M = /* @__PURE__ */ fr(), N = /* @__PURE__ */ ur(), T = /* @__PURE__ */ sr(), j = /* @__PURE__ */ cr(), k = /* @__PURE__ */ lr(), s = /* @__PURE__ */ Ar(), c = /* @__PURE__ */ dr(), C = /* @__PURE__ */ mr(), D = /* @__PURE__ */ vr(), W = /* @__PURE__ */ Pr(), J = /* @__PURE__ */ gr(), V = /* @__PURE__ */ _r(), z = /* @__PURE__ */ hr(), H = /* @__PURE__ */ Sr(), L = /* @__PURE__ */ Er(), O = Function, F = function(y) {
    try {
      return O('"use strict"; return (' + y + ").constructor;")();
    } catch {
    }
  }, m = /* @__PURE__ */ qr(), Y = /* @__PURE__ */ Ir(), R = function() {
    throw new c();
  }, K = m ? (function() {
    try {
      return arguments.callee, R;
    } catch {
      try {
        return m(arguments, "callee").get;
      } catch {
        return R;
      }
    }
  })() : R, l = br()(), o = Fr(), Q = Rr(), X = Ur(), B = wr(), v = Or(), A = {}, Z = typeof Uint8Array > "u" || !o ? r : o(Uint8Array), u = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? r : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? r : ArrayBuffer,
    "%ArrayIteratorPrototype%": l && o ? o([][Symbol.iterator]()) : r,
    "%AsyncFromSyncIteratorPrototype%": r,
    "%AsyncFunction%": A,
    "%AsyncGenerator%": A,
    "%AsyncGeneratorFunction%": A,
    "%AsyncIteratorPrototype%": A,
    "%Atomics%": typeof Atomics > "u" ? r : Atomics,
    "%BigInt%": typeof BigInt > "u" ? r : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? r : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? r : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? r : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": N,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": T,
    "%Float16Array%": typeof Float16Array > "u" ? r : Float16Array,
    "%Float32Array%": typeof Float32Array > "u" ? r : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? r : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? r : FinalizationRegistry,
    "%Function%": O,
    "%GeneratorFunction%": A,
    "%Int8Array%": typeof Int8Array > "u" ? r : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? r : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? r : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": l && o ? o(o([][Symbol.iterator]())) : r,
    "%JSON%": typeof JSON == "object" ? JSON : r,
    "%Map%": typeof Map > "u" ? r : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !l || !o ? r : o((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": M,
    "%Object.getOwnPropertyDescriptor%": m,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? r : Promise,
    "%Proxy%": typeof Proxy > "u" ? r : Proxy,
    "%RangeError%": j,
    "%ReferenceError%": k,
    "%Reflect%": typeof Reflect > "u" ? r : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? r : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !l || !o ? r : o((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? r : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": l && o ? o(""[Symbol.iterator]()) : r,
    "%Symbol%": l ? Symbol : r,
    "%SyntaxError%": s,
    "%ThrowTypeError%": K,
    "%TypedArray%": Z,
    "%TypeError%": c,
    "%Uint8Array%": typeof Uint8Array > "u" ? r : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? r : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? r : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? r : Uint32Array,
    "%URIError%": C,
    "%WeakMap%": typeof WeakMap > "u" ? r : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? r : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? r : WeakSet,
    "%Function.prototype.call%": v,
    "%Function.prototype.apply%": B,
    "%Object.defineProperty%": Y,
    "%Object.getPrototypeOf%": Q,
    "%Math.abs%": D,
    "%Math.floor%": W,
    "%Math.max%": J,
    "%Math.min%": V,
    "%Math.pow%": z,
    "%Math.round%": H,
    "%Math.sign%": L,
    "%Reflect.getPrototypeOf%": X
  };
  if (o)
    try {
      null.error;
    } catch (y) {
      var rr = o(o(y));
      u["%Error.prototype%"] = rr;
    }
  var er = function y(e) {
    var a;
    if (e === "%AsyncFunction%")
      a = F("async function () {}");
    else if (e === "%GeneratorFunction%")
      a = F("function* () {}");
    else if (e === "%AsyncGeneratorFunction%")
      a = F("async function* () {}");
    else if (e === "%AsyncGenerator%") {
      var t = y("%AsyncGeneratorFunction%");
      t && (a = t.prototype);
    } else if (e === "%AsyncIteratorPrototype%") {
      var n = y("%AsyncGenerator%");
      n && o && (a = o(n.prototype));
    }
    return u[e] = a, a;
  }, x = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, P = Br(), _ = /* @__PURE__ */ xr(), tr = P.call(v, Array.prototype.concat), or = P.call(B, Array.prototype.splice), G = P.call(v, String.prototype.replace), h = P.call(v, String.prototype.slice), ar = P.call(v, RegExp.prototype.exec), nr = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, ir = /\\(\\)?/g, yr = function(e) {
    var a = h(e, 0, 1), t = h(e, -1);
    if (a === "%" && t !== "%")
      throw new s("invalid intrinsic syntax, expected closing `%`");
    if (t === "%" && a !== "%")
      throw new s("invalid intrinsic syntax, expected opening `%`");
    var n = [];
    return G(e, nr, function(p, d, i, S) {
      n[n.length] = i ? G(S, ir, "$1") : d || p;
    }), n;
  }, pr = function(e, a) {
    var t = e, n;
    if (_(x, t) && (n = x[t], t = "%" + n[0] + "%"), _(u, t)) {
      var p = u[t];
      if (p === A && (p = er(t)), typeof p > "u" && !a)
        throw new c("intrinsic " + e + " exists, but is not available. Please file an issue!");
      return {
        alias: n,
        name: t,
        value: p
      };
    }
    throw new s("intrinsic " + e + " does not exist!");
  };
  return w = function(e, a) {
    if (typeof e != "string" || e.length === 0)
      throw new c("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof a != "boolean")
      throw new c('"allowMissing" argument must be a boolean');
    if (ar(/^%?[^%]*%?$/, e) === null)
      throw new s("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var t = yr(e), n = t.length > 0 ? t[0] : "", p = pr("%" + n + "%", a), d = p.name, i = p.value, S = !1, U = p.alias;
    U && (n = U[0], or(t, tr([0, 1], U)));
    for (var E = 1, g = !0; E < t.length; E += 1) {
      var f = t[E], q = h(f, 0, 1), I = h(f, -1);
      if ((q === '"' || q === "'" || q === "`" || I === '"' || I === "'" || I === "`") && q !== I)
        throw new s("property names with quotes must have matching quotes");
      if ((f === "constructor" || !g) && (S = !0), n += "." + f, d = "%" + n + "%", _(u, d))
        i = u[d];
      else if (i != null) {
        if (!(f in i)) {
          if (!a)
            throw new c("base intrinsic for " + e + " exists, but the property is not available.");
          return;
        }
        if (m && E + 1 >= t.length) {
          var b = m(i, f);
          g = !!b, g && "get" in b && !("originalValue" in b.get) ? i = b.get : i = i[f];
        } else
          g = _(i, f), i = i[f];
        g && !S && (u[d] = i);
      }
    }
    return i;
  }, w;
}
export {
  ne as __require
};
//# sourceMappingURL=index.es226.js.map
